window.cacu = window.cacu || {};
window.cacu = {
    LOCAL_CONFIG: {},
    LOCALE: "de",
    BACKEND_URL: "https://backend.leinwandmomente.de/de",
    parseDateToString: function(pDate) {
        if (pDate == '') return '';
        pDate = new Date(pDate);
        var dateString = pDate.getDate();
        var monthString = pDate.getMonth() + 1;
        var yearString = pDate.getFullYear();
        if (dateString < 10) {
            dateString = '0' + dateString;
        }
        if (monthString < 10) {
            monthString = '0' + monthString;
        }
        return dateString + "." + monthString + "." + yearString;
    },
    parseDateTimeToString: function(pDate) {
        if (pDate == '') return '';
        if (typeof(pDate) == 'string') {
            var date = pDate.split('T')[0];
            var time = pDate.split('T')[1];
            var dateString = parseInt(date.split('-')[2]);
            var monthString = parseInt(date.split('-')[1]);
            var yearString = parseInt(date.split('-')[0]);
            if (time) {
                var hoursString = parseInt(time.split(':')[0]);
                var minutesString = parseInt(time.split(':')[1]);
            }
        } else {
            pDate = new Date(pDate);
            var dateString = pDate.getDate();
            var monthString = pDate.getMonth() + 1;
            var yearString = pDate.getFullYear();
            var hoursString = pDate.getHours();
            var minutesString = pDate.getMinutes();
        }
        if (dateString < 10) {
            dateString = '0' + dateString;
        }
        if (monthString < 10) {
            monthString = '0' + monthString;
        }
        if (hoursString < 10) {
            hoursString = '0' + hoursString;
        }
        if (minutesString < 10) {
            minutesString = '0' + minutesString;
        }
        return dateString + "." + monthString + "." + yearString + ", " + hoursString + ":" + minutesString + " Uhr";
    },
    parseStringToDateTime: function(pString) {
        var regEx1 = /(\d{2}).(\d{2}).(\d{4}), (\d{2}):(\d{2})/;
        var regEx2 = /(\d{2}).(\d{2}).(\d{4})/;
        if (regEx1.test(pString)) {
            var dateArray = regEx1.exec(pString);
            return dateArray[3] + "-" + dateArray[2] + "-" + dateArray[1] + "T" + dateArray[4] + ":" + dateArray[5];
        } else if (regEx2.test(pString)) {
            var dateArray = regEx2.exec(pString);
            return dateArray[3] + "-" + dateArray[2] + "-" + dateArray[1];
        }
        return pString;
        //return '';
    },
    getURLParams: function(pKey) {
        var url = new URL(window.location.href);
        var value = url.searchParams.get(pKey);
        if (pKey != 'lm' && pKey != 'edit_order' && !value) {
            if (pKey in window.cacu.LOCAL_CONFIG) {
                value = window.cacu.LOCAL_CONFIG[pKey];
            }
        }
        return value;
    },
    isInEditMode: function() {
        var isLM = window.cacu.getURLParams('lm');
        var hasLineItem = window.cacu.getURLParams('line_item');
        if (isLM != undefined && hasLineItem != undefined) {
            return true;
        } else {
            return false;
        }
    },
    doesFieldContainsValue: function(pField, pValue) {
        for (var i = 0; i < pField.length; i++) {
            if (pField[i]['id'] === pValue) return true;
        }
        return false;
    }
};

createCaCu();
function createCaCu() {   
      
    if(CONFIG == undefined) {        
		var xhr = new XMLHttpRequest();
        xhr.open('GET', window.cacu.BACKEND_URL + '/fields/' + lmProductID, true);        
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
                var pFields = JSON.parse(xhr.responseText);
                console.log(pFields)
                if (JSON.stringify(pFields) !== '{}') {                    
                    CONFIG = pFields;                    
                    create();                    
                }
            }
        };        
        xhr.onerror = function () {
            console.error('Fehler beim Abrufen der Daten');
        };        
        xhr.send();      
	} else {		
		create();		
	}	
    
    function create() {
        console.log("create");
        loadConfig();
        let fieldsHTML = generate(CONFIG['fields']);
        document.getElementById('lm-fields').innerHTML = fieldsHTML;   
        document.body.dispatchEvent(new Event('cacu.created'));
        if(lmProductType.includes('Leinwand') || lmProductType.includes('Poster')|| lmProductType == 'Malen nach Zahlen') {
           generateFloatingFrames();
        }       
    }

    function generate(pFields) {
        var fieldsHTML = "";
        for (var i = 0; i < pFields.length; i++) {
            var type = pFields[i]['type'];
            switch (type) {
                case 'image-swatch':
                    fieldsHTML += generateImageSwatch(pFields[i]);
                    break;
                case 'number-swatch':
                    fieldsHTML += generateNumberSwatch(pFields[i]);
                    break;
                case 'dropdown':
                    fieldsHTML += generateDropdown(pFields[i]);
                    break;
                case 'upload':
                    fieldsHTML += generateUpload(pFields[i]);
                    break;
                case 'multi-upload':
                    fieldsHTML += generateMultiUpload(pFields[i]);
                    break;
                case 'checkbox':
                    fieldsHTML += generateCheckbox(pFields[i]);
                    break;
                case 'checked-text':
                    fieldsHTML += generateCheckedText(pFields[i]);
                    break;
                case 'datetime':
                    fieldsHTML += generateDateTime(pFields[i]);
                    break;
                case 'date':
                    fieldsHTML += generateDate(pFields[i]);
                    break;
                case 'text':
                    fieldsHTML += generateText(pFields[i]);
                    break;
                case 'text-and-select':
                    fieldsHTML += generateTextAndSelect(pFields[i]);
                    break;
                case 'textarea':
                    fieldsHTML += generateTextArea(pFields[i]);
                    break;
                case 'number':
                    fieldsHTML += generateNumber(pFields[i]);
                    break;
                case 'location':
                    fieldsHTML += generateLocation(pFields[i]);
                    break;
                case 'map':
                    fieldsHTML += generateMap(pFields[i]);
                    break;
                case 'wrapper':
                    fieldsHTML += generateWrapper(pFields[i]);
                    break;
            }
        }
        return fieldsHTML;
    }

    function generateFloatingFrames() {  
        var isEditOrder = window.cacu.getURLParams('edit_order');
      
        for(let i=0; i < lmProductVariants.length; i++) {
             const withoutVariant = lmProductVariants.find((variant) => variant.option1 == lmProductVariants[i].option1 && variant.option2 == "Ohne");
             const framePrice = lmProductVariants[i].price - withoutVariant.price;  
             if(theme.settings.moneyFormat.includes('{amount}')) {
               var framePriceString = theme.settings.moneyFormat.replace("\{\{amount\}\}", (framePrice / 100).toFixed(2));
             } else {
               var framePriceString = theme.settings.moneyFormat.replace("\{\{amount_with_comma_separator\}\}", (framePrice / 100).toFixed(2).replace('.', ','))
             }       
             lmProductVariants[i].frame_price = framePrice > 0 ? '+ ' + framePriceString : '';
        }      
        
        var urlValue = window.cacu.getURLParams('frame');          
        const frames = [
          {'id': '', 'name': "Ohne",  'image': 'https://cdn.shopify.com/s/files/1/0288/6965/6658/files/Frame-No.jpg?v=1741015950'},
          {'id': 'black', 'name': "Schwarz", 'image': 'https://cdn.shopify.com/s/files/1/0288/6965/6658/files/Frame-Black_512x_c.jpg?v=1741683503'},
          {'id': 'white', 'name': "Weiß", 'image': 'https://cdn.shopify.com/s/files/1/0288/6965/6658/files/Frame-White_512x_c.jpg?v=1741683503'}
        ];
        let swatch = "";
        let activeIndex = 0;
        for (var i = 0; i < frames.length; i++) {
          let active = "";          
          if(urlValue && urlValue == frames[i]['id']) {
            active = "active";
            activeIndex = i;
          } else if(!urlValue && i == 0) {
            active = "active";
            activeIndex = i;
          }
          swatch += "<div class='frame-item " + active + "' data-frame-id='" + frames[i]['id'] + "' data-frame-name='" + frames[i]['name'] + "' style='background-image: url(" + frames[i]['image'] + ");background-color: undefined;'></div>";
        }
        const selectedVariant = lmProductVariants.find((variant) => variant.option1 == lmSelectedVariant.option1 && variant.option2 == frames[activeIndex]['name']);       
        
        let html = "<div class='lm-floating-frames " + (isEditOrder != undefined ? 'hide' : '') + "'><div class='title'><label class='variant__label'>Premium Rahmen<span class='frame-name'>" + frames[activeIndex]['name'] + "</span></label><span class='price'>" + selectedVariant.frame_price + "</span></div><div class='no-frame-selectable' style='" + (selectedVariant.option1.includes('160') ? 'display:block': 'display:none') + "'>Für diese Größe ist kein Rahmen wählbar.</div><div class='swatch' style='" + (selectedVariant.option1.includes('160') ? 'display:none': '') + "'>" + swatch + "</div></div>";  
        document.querySelector('#lm-cc-form form').insertAdjacentHTML('afterend', html);         
    }


    function loadConfig() {
        if (window.cacu.isInEditMode()) return;
        try {
            var storage = localStorage.getItem('lm-user-config');
            if (storage) {
                window.cacu.LOCAL_CONFIG = JSON.parse(storage);
            }
        } catch (e) {}

        var paramValue = new URLSearchParams(window.location.search).get('lm-user-config');
        if (paramValue != undefined) {
            paramValue = JSON.parse(decodeURIComponent(paramValue));
            window.cacu.LOCAL_CONFIG = Object.assign({}, window.cacu.LOCAL_CONFIG, paramValue);
        }
    }

    function generateImageSwatch(pImageSwatch) {
        var urlValue = window.cacu.getURLParams(pImageSwatch['id']);
        var doesFieldContainURLValue = window.cacu.doesFieldContainsValue(pImageSwatch['options'], urlValue);
        var constainsCustomImage = false;
        var activeID = (urlValue && doesFieldContainURLValue) ? urlValue : ((pImageSwatch['default']) ? pImageSwatch['default'] : 0);
        var size = (pImageSwatch['size']) ? 'size-' + pImageSwatch['size'].toLowerCase() : '';
        var optionsHTML = "";
        var tagLabel = "";
        for (var j = 0; j < pImageSwatch['options'].length; j++) {
            var id = pImageSwatch['options'][j]['id'];
            if (activeID == pImageSwatch['options'][j]['id']) {
                var active = 'active';
                tagLabel = pImageSwatch['options'][j]['name'];
            } else {
                var active = '';
            }
            if (id != 'custom') {
                var img = (pImageSwatch['options'][j]['img'] != '') ? 'background-image: url(' + pImageSwatch['options'][j]['img'] + ');' : '';
                var color = (pImageSwatch['options'][j]['color'] != '') ? 'background-color: ' + pImageSwatch['options'][j]['color'] + ';' : '';
                optionsHTML += "<div class='swatch-item " + active + "' data-id='" + pImageSwatch['id'] + "' data-option-id='" + pImageSwatch['options'][j]['id'] + "' data-option-name='" + pImageSwatch['options'][j]['name'] + "' style='" + img + color + "'></div>";
            } else {
                constainsCustomImage = true;
                var imageKey = window.cacu.getURLParams(pImageSwatch['id'] + '_key');
                if (!imageKey) {
                    imageKey = "";
                }
                var imagePoints = window.cacu.getURLParams(pImageSwatch['id'] + '_points');
                if (imagePoints) {
                    imagePoints = imagePoints.split('_');
                } else {
                    imagePoints = [];
                }
                optionsHTML += "<div class='swatch-item " + active + "' data-id='" + pImageSwatch['id'] + "' data-option-id='custom' data-option-name='" + pImageSwatch['options'][j]['name'] + "'>";
                optionsHTML += "<label for='lm-file-uploader-" + pImageSwatch['id'] + "'></label>";
                optionsHTML += "<input type='file' id='lm-file-uploader-" + pImageSwatch['id'] + "' accept='image/*,.heic,.heif' class='lm-file-uploader' data-id='" + pImageSwatch['id'] + "' data-option-id='" + pImageSwatch['options'][j]['id'] + "' data-key='" + imageKey + "' data-points='" + JSON.stringify(imagePoints) + "' data-ratio='" + pImageSwatch['options'][j]['ratio'] + "'>";
                optionsHTML += "</div>";
            }
        }
        var HTML = "<div class='field image-swatch " + size + "' data-id-group='" + pImageSwatch['id'] + "'>" + "<div>" + "<label>" + pImageSwatch['name'] + "<span class='tag'>" + tagLabel + "</span></label>" + "</div><span class='lm-fb-hint-wrapper'></span>" + "<div>" + optionsHTML + "</div>" + "</div>";
        if (constainsCustomImage) {
            HTML += "<div class='lm-img-cropper' data-id-group='" + pImageSwatch['id'] + "'></div>"
        }
        return HTML;
    }

    function generateNumberSwatch(pNumberSwatch) {
        var urlValue = window.cacu.getURLParams(pNumberSwatch['id']);
        var doesFieldContainURLValue = window.cacu.doesFieldContainsValue(pNumberSwatch['options'], urlValue);
        var hidden = (pNumberSwatch['visibility'] == 'hidden') ? 'lm-hide' : '';
        var optionsHTML = "";
        var tooltipHTML = "";
        var activeID = (urlValue && doesFieldContainURLValue) ? urlValue : ((pNumberSwatch['default']) ? pNumberSwatch['default'] : '0');
        var size = (pNumberSwatch['size']) ? 'size-' + pNumberSwatch['size'].toLowerCase() : '';
        for (var j = 0; j < pNumberSwatch['options'].length; j++) {
            var active = (activeID.toLowerCase() == pNumberSwatch['options'][j]['id'].toLowerCase()) ? 'active' : '';
            var attributes = pNumberSwatch['options'][j]['attributes'];
            var attrString = '';
            for (var k in attributes) {
                attrString += k + "='" + attributes[k] + "'";
            }
            optionsHTML += "<span class='swatch-item " + active + "' data-id='" + pNumberSwatch['id'] + "' data-option-id='" + pNumberSwatch['options'][j]['id'] + "' data-option-name='" + pNumberSwatch['options'][j]['name'] + "' " + attrString + ">" + pNumberSwatch['options'][j]['name'] + "</span>";
        }
        if(pNumberSwatch['tooltip']) {
            tooltipHTML = "<div class='lm-tooltip'><i class='tooltip-icon fas fa-info'></i><div class='tooltip-container'>" + pNumberSwatch['tooltip'] + "</div></div>";
        }
        var HTML = "<div class='field number-swatch " + hidden + " " + size + "' data-id-group='" + pNumberSwatch['id'] + "'>" + "<label>" + pNumberSwatch['name'] + "" + tooltipHTML + "</label>" + "<div>" + optionsHTML + "</div>" + "</div>";
        return HTML;
    }

    function generateDropdown(pDropdown) {
        var urlValue = window.cacu.getURLParams(pDropdown['id']);
        var doesFieldContainURLValue = window.cacu.doesFieldContainsValue(pDropdown['options'], urlValue);
        var hidden = (pDropdown['visibility'] == 'hidden') ? 'lm-hide' : '';
        var optionsHTML = "";
        var activeID = (urlValue && doesFieldContainURLValue) ? urlValue : ((pDropdown['default']) ? pDropdown['default'] : 0);
        var groupOpen = false;
        for (var j = 0; j < pDropdown['options'].length; j++) {
            if (groupOpen == false && pDropdown['options'][j]['group']) {
                groupOpen = true;
                optionsHTML += "<optgroup label='" + pDropdown['options'][j]['group'] + "'>";
            }
            var selected = (activeID == pDropdown['options'][j]['id']) ? 'selected' : '';
            optionsHTML += "<option value='" + pDropdown['options'][j]['id'] + "' " + selected + ">" + pDropdown['options'][j]['name'] + "</option>";
            if (j >= pDropdown['options'].length - 1 || !pDropdown['options'][j]['group'] || !pDropdown['options'][j + 1]['group'] || pDropdown['options'][j]['group'] != pDropdown['options'][j + 1]['group']) {
                optionsHTML += "</optgroup>";
                groupOpen = false;
            }
        }
        var HTML = "<div class='field dropdown" + hidden + "' data-id-group='" + pDropdown['id'] + "'>" + "<label>" + pDropdown['name'] + "</label><i class='icon " + getIconName("dropdown", pDropdown['id']) + "'></i><select data-id='" + pDropdown['id'] + "'>" + optionsHTML + "</select></div>";
        return HTML;
    }

    function generateCheckbox(pCheckbox) {
        var urlValue = window.cacu.getURLParams(pCheckbox['id']);
        var checked = '';
        if (urlValue && urlValue.toLowerCase() == 'ja') {
            checked = 'checked';
        } else if (urlValue && urlValue.toLowerCase() == 'nein') {
            checked = '';
        } else {
            if (pCheckbox['checked']) {
                checked = 'checked';
            } else {
                checked = '';
            }
        }

        return "<div class='field checkbox'>" + "<label><div><input type='checkbox' data-id='" + pCheckbox['id'] + "' " + checked + "><span></span></div><span>" + pCheckbox['name'] + "</span></label>" + "</div>";
    }

    function generateCheckedText(pCheckedText) {
        var urlValue = window.cacu.getURLParams(pCheckedText['id']);
        var checked = (urlValue) ? 'checked' : ((pCheckedText['checked']) ? 'checked' : '');
        var disabled = (urlValue) ? '' : ((pCheckedText['checked']) ? '' : 'disabled');
        var hidden = (pCheckedText['default']) ? '' : 'lm-hide';
        var required = (urlValue || pCheckedText['required']) ? 'required' : '';
        var value = (urlValue) ? urlValue : pCheckedText['value'];
        var transform = (pCheckedText['transform'] == undefined) ? '' : 'lm-' + pCheckedText['transform'];
        var html = "<div class='field checked-text" + hidden + "' data-id-group='" + pCheckedText['id'] + "'>";
        html += "<label>" + pCheckedText['name'] + "</label>";
        html += "<div>";
        html += "<input type='checkbox' data-id='" + pCheckedText['id'] + "' " + checked + ">";
        html += "<input " + required + " " + disabled + " class='" + transform + "' data-id='" + pCheckedText['id'] + "' type='text' placeholder='" + pCheckedText['placeholder'] + "' value='" + value + "'>";
        html += "</div>";
        html += "</div>";
        return html;
    }

    function generateNumber(pNumber) {
        var urlValue = window.cacu.getURLParams(pNumber['id']);
        var required = '';
        var hidden = '';
        if (pNumber['required'] && pNumber['default']) {
            required = 'required';
            hidden = "";
        } else if (!pNumber['default']) {
            hidden = 'lm-hide';
            required = '';
        }
        if (urlValue) {
            var value = urlValue;
            hidden = '';
        } else if (pNumber['value']) {
            var value = pNumber['value'];
        } else {
            var value = '';
        }
        return "<div class='field text " + hidden + "' data-id-group='" + pNumber['id'] + "'><input " + required + " data-id='" + pNumber['id'] + "' type='number' class='" + ((value != '') ? "filled" : "") + "' value='" + value + "'><label>" + pNumber['name'] + "</label></div>";
    }

    function generateText(pText) {
        var urlValue = window.cacu.getURLParams(pText['id']);
        var css = (pText['css'] != undefined) ? pText['css'] : '';
        var required = '';
        var hidden = '';
        if (pText['required'] && pText['default']) {
            required = 'required';
            hidden = "";
        } else if (!pText['default']) {
            hidden = 'lm-hide';
            required = '';
        }
        if (urlValue) {
            var value = urlValue;
            hidden = '';
        } else if (pText['value']) {
            var value = pText['value'];
        } else {
            var value = '';
        }
        var transform = (pText['transform'] == undefined) ? '' : 'lm-' + pText['transform'];
        return "<div class='field text " + transform + " " + hidden + "' data-id-group='" + pText['id'] + "' style='" + css + "'><input " + required + "  oninput=\"this.value.trim() !== '' ? this.classList.add('filled') : this.classList.remove('filled')\" class='" + transform + " " + ((value != '') ? "filled" : "") + "' data-id='" + pText['id'] + "' type='text' autocomplete='off' value='" + value + "'><label>" + pText['name'] + "</label><i class='icon " + getIconName("text", pText['id']) + "'></i></div>";
    }

    function generateTextAndSelect(pTextAndSelect) {
        var urlValue = window.cacu.getURLParams(pTextAndSelect['id']);
        var required = '';
        var hidden = '';
        if (pTextAndSelect['required'] && pTextAndSelect['default']) {
            required = 'required';
            hidden = "";
        } else if (!pTextAndSelect['default']) {
            hidden = 'lm-hide';
            required = '';
        }
        if (urlValue) {
            var value = urlValue;
            hidden = '';
        } else if (pTextAndSelect['value']) {
            var value = pTextAndSelect['value'];
        } else {
            var value = '';
        }

        // Selection
        var selection = "";
        var activeImage = "";
        var urlValue = window.cacu.getURLParams(pTextAndSelect['id'] + "_select");
        if (urlValue) {
            //check if urlValue exists in selection
            var selectValue = pTextAndSelect['selection_default'];

            for (var i = 0; i < pTextAndSelect['selection'].length; i++) {
                if (pTextAndSelect['selection'][i]['id'] == urlValue) {
                    var selectValue = urlValue;
                    break;
                }
            }


        } else if (pTextAndSelect['selection_default']) {
            var selectValue = pTextAndSelect['selection_default'];
        } else {
            var selectValue = '';
        }
        var hasName = false;
        for (var i = 0; i < pTextAndSelect['selection'].length; i++) {
            var id = pTextAndSelect['selection'][i]['id'];
            var name = pTextAndSelect['selection'][i]['name'];
            var style = (pTextAndSelect['selection'][i].hasOwnProperty('img') && pTextAndSelect['selection'][i]['img'] != '') ? 'background-image: url(' + pTextAndSelect['selection'][i]['img'] + ');' : '';
            if (style == '') {
                style = (pTextAndSelect['selection'][i].hasOwnProperty('color') && pTextAndSelect['selection'][i]['color'] != '') ? 'background-color: ' + pTextAndSelect['selection'][i]['color'] + ';' : '';
            }

            if (name != '') {
                hasName = true;
            }

            if (selectValue == id) {
                var active = 'active';
                activeImage = style;
            } else {
                var active = '';
            }

            selection += "<div class='item " + active + "' style='" + style + "' data-id='" + id + "' data-option-name='" + name + "'><span>" + name + "</span></div>";
        }
        return "<div class='field text text_and_select " + hidden + "' data-id-group='" + pTextAndSelect['id'] + "'><div class='wrapper'><input required oninput=\"this.value.trim() !== '' ? this.classList.add('filled') : this.classList.remove('filled')\" data-id='" + pTextAndSelect['id'] + "' type='text' autocomplete='off' value='" + value + "'><label>" + pTextAndSelect['name'] + "</label><i class='icon " + getIconName("text", pTextAndSelect['id']) + "'></i><div class='select-wrapper " + (pTextAndSelect.hasOwnProperty('selection_name') ? '' : 'no-name') + "'><span>" + pTextAndSelect['selection_name'] + "</span><div style='" + activeImage + "'></div></div></div>" +
            "<div class='selection' data-has-name='" + hasName + "'><div class='inner'>" + selection + "</div></div></div>";
    }

    function generateTextArea(pTextArea) {
        var urlValue = window.cacu.getURLParams(pTextArea['id']);
        var required = '';
        var hidden = '';
        if (pTextArea['required'] && pTextArea['default']) {
            required = 'required';
            hidden = "";
        } else if (!pTextArea['default']) {
            hidden = 'lm-hide';
            required = '';
        }
        if (urlValue) {
            var value = urlValue;
            hidden = '';
        } else if (pTextArea['value']) {
            var value = pTextArea['value'];
        } else {
            var value = '';
        }
        return "<div class='field textarea " + hidden + "' data-id-group='" + pTextArea['id'] + "'><textarea oninput=\"this.value.trim() !== '' ? this.classList.add('filled') : this.classList.remove('filled')\" class='" + ((value != '') ? "filled" : "") + "' rows=" + pTextArea['rows'] + " cols=" + pTextArea['cols'] + " required data-id='" + pTextArea['id'] + "'>" + value + "</textarea><label>" + pTextArea['name'] + "</label><i class='icon " + getIconName("text", pTextArea['id']) + "'></i></div>";
    }

    function generateMultiUpload(pUpload) {
        var counter = 1;
        var contentBoxItems = "";
        while (window.cacu.getURLParams(pUpload['id'] + counter + '_key') != null) {
            var imageKey = window.cacu.getURLParams(pUpload['id'] + counter + '_key');
            var url = window.cacu.BACKEND_URL + '/upload/' + imageKey;
            var imagePoints = window.cacu.getURLParams(pUpload['id'] + counter + '_points');
            if (imagePoints) {
                imagePoints = imagePoints.split('_');
                url += "?crop=" + imagePoints.join(',');
            } else {
                imagePoints = [];
            }
            counter += 1;
            contentBoxItems += "<div class='item' data-key='" + imageKey + "' data-points='" + JSON.stringify(imagePoints) + "'><div class='inner-item' style='background-image: url(" + url + ")'><div class='actions'><div class='edit'><i class='far fa-edit'></i></div><div class='remove'><i class='fas fa-trash-alt'></i></div></div></div></div>";
        }
        console.log(pUpload);
        var HTML = "<div class='field multi-upload upload' data-id-group='" + pUpload['id'] + "' data-id='" + pUpload['id'] + "' data-editable=" + (pUpload.hasOwnProperty("editable") ? pUpload['editable'] : true) + " data-limit=" + pUpload['limit'] + " data-image-length='" + (counter - 1) + "'><label>" + pUpload['name'] + "<span class='limit-span'>(" + (counter - 1) + "/" + pUpload['limit'] + ")</span></label><span class='lm-fb-hint-wrapper'></span><div class='multi-upload-container'><div class='upload-box'><div class='upload-box-content'>" + contentBoxItems + "</div></div><label class='btn' for='lm-multi-file-uploader-" + pUpload['id'] + "'><i class='fas fa-upload'></i>" + pUpload['placeholder'] + "<input hidden type='file' multiple accept='image/*,.heic,.heif' id='lm-multi-file-uploader-" + pUpload['id'] + "' class='lm-multi-file-uploader' data-id='" + pUpload['id'] + "' data-option-id='" + pUpload['id'] + "' data-ratio='" + pUpload['ratio'] + "'></label></div></div>";
        return HTML;
    }

    function generateUpload(pUpload) {
        var imageKey = window.cacu.getURLParams(pUpload['id'] + '_key');
        if (!imageKey) {
            imageKey = "";
        }
        var imagePoints = window.cacu.getURLParams(pUpload['id'] + '_points');
        if (imagePoints) {
            imagePoints = imagePoints.split('_');
        } else {
            imagePoints = [];
        }

        var hidden = '';
        if (pUpload['default']) {
            hidden = "";
        } else if (!pUpload['default']) {
            hidden = 'lm-hide';
        }

        var label = "<div class='label'><label>" + pUpload['name'] + "</label><i class='fas fa-trash-alt'></i></div>";
        var HTML = "<div class='field upload " + hidden + "' data-id-group='" + pUpload['id'] + "' data-id='" + pUpload['id'] + "'>" + label + "<div class='upload-container'><div class='lm-img-cropper' data-id-group='" + pUpload['id'] + "'></div><span class='lm-fb-hint-wrapper'></span><label class='btn' for='lm-file-uploader-" + pUpload['id'] + "'><i class='fas fa-upload'></i>" + pUpload['placeholder'] + "<input hidden type='file' accept='image/*,.heic,.heif' id='lm-file-uploader-" + pUpload['id'] + "' class='lm-file-uploader' data-id='" + pUpload['id'] + "' data-option-id='" + pUpload['id'] + "' data-key='" + imageKey + "' data-points='" + JSON.stringify(imagePoints) + "' data-ratio='" + pUpload['ratio'] + "'></label></div></div>";
        return HTML;
    }

    function generateDateTime(pDateTime) {
        var urlValue = window.cacu.getURLParams(pDateTime['id']);
        var required = '';
        var hidden = '';
        if (pDateTime['required'] && pDateTime['default']) {
            required = 'required';
            hidden = "";
        } else if (!pDateTime['default']) {
            hidden = 'lm-hide';
            required = '';
        }
        if (urlValue) {
            var value = urlValue;
            hidden = '';
        } else if (pDateTime['value']) {
            var value = pDateTime['value'];
        } else {
            var value = '';
        }
        return "<div class='field datetime " + hidden + "' style='" + pDateTime['css'] + "' data-id-group='" + pDateTime['id'] + "'><input " + required + " class='" + ((value != "") ? 'has-input' : '') + "' data-id='" + pDateTime['id'] + "' type='text' inputmode='numeric' name='' data-value='" + value + "' value='" + window.cacu.parseDateTimeToString(value) + "'><label>" + pDateTime['name'] + "</label><i class='icon far fa-calendar-alt'></i><div class='flatpickr-container'><i class='far fa-calendar-alt pick-date'></i><input type='text'></div></div>";
    }

    function generateDate(pDate) {
        var urlValue = window.cacu.getURLParams(pDate['id']);
        var required = '';
        var hidden = '';
        if (pDate['required'] && pDate['default']) {
            required = 'required';
            hidden = "";
        } else if (!pDate['default']) {
            hidden = 'lm-hide';
            required = '';
        }
        if (urlValue) {
            var value = urlValue;
            hidden = '';
        } else if (pDate['value']) {
            var value = pDate['value'];
        } else {
            var value = '';
        }
        return "<div class='field date " + hidden + "' style='" + pDate['css'] + "' data-id-group='" + pDate['id'] + "'><input " + required + " class='" + ((value != "") ? 'has-input' : '') + "' data-id='" + pDate['id'] + "' type='text' inputmode='numeric' name='' data-value='" + value + "' value='" + window.cacu.parseDateToString(value) + "'><label>" + pDate['name'] + "</label><i class='icon fas fa-calendar-day'></i><div class='flatpickr-container'><i class='far fa-calendar-alt pick-date'></i><input type='text'></div></div>";
    }

    function generateLocation(pLocation) {
        var urlValue = window.cacu.getURLParams(pLocation['id']);
        var css = (pLocation['css'] != undefined) ? pLocation['css'] : '';

        if (urlValue) {
            var urlValueParts = urlValue.split(";");
            var lng = urlValueParts[0];
            var lat = urlValueParts[1];
            var value = urlValueParts[2];
        } else {
            var lng = '0';
            var lat = '0';
            var value = '';
        }
        return "<div class='field location button' data-id-group='" + pLocation['id'] + "' data-name='" + value + "' data-lng='" + lng + "' data-lat='" + lat + "' style='" + css + "'><div><input value='" + value + "' data-id='" + pLocation['id'] + "' type='text' autocomplete='off'><label>" + pLocation['name'] + "</label><i class='icon_suffix fas fa-search'></i><i class='icon_suffix fas fa-times'></i></div><ul class='lm-search-results' data-length='0'></ul></div>";
    }

    function generateMap(pMap) {
        var urlValue = window.cacu.getURLParams(pMap['id']);
        var css = (pMap['css'] != undefined) ? pMap['css'] : '';

        var defaultStyle = '';
        for (var i = 0; i < pMap['styles'].length; i++) {
            var isDefault = pMap['styles'][i]['default'];
            if (isDefault) {
                defaultStyle = pMap['styles'][i]['id'];
            }
        }

        if (urlValue) {
            var urlValueParts = urlValue.split(";");
            var lng = urlValueParts[0];
            var lat = urlValueParts[1];
            var zoom = urlValueParts[2];
            var viewZoom = urlValueParts[3];
            var style = urlValueParts[4];
            var hasStyle = false;
            for (var i = 0; i < pMap['styles'].length; i++) {
                var id = pMap['styles'][i]['id'];
                if (id == style) {
                    hasStyle = true;
                }
            }
            if (hasStyle == false) {
                style = defaultStyle;
            }
            var marker = urlValueParts[5];
            var markerLng = urlValueParts[6];
            var markerLat = urlValueParts[7];
        } else {
            if (window.cacu.LOCALE == 'fr') {
                var lng = 2.213749;
                var lat = 46.227638;
                var zoom = 4;
            } else {
                var lng = 10.4541194;
                var lat = 51.1642292;
                var zoom = 4;
            }
            var viewZoom = zoom;
            var style = defaultStyle;
            var marker = '';
            for (var i = 0; i < pMap['marker'].length; i++) {
                var isDefault = pMap['marker'][i]['default'];
                if (isDefault) {
                    marker = pMap['marker'][i]['id'];
                }
            }
            var markerLng = pMap['lng'];
            var markerLat = pMap['lat'];
        }
        return "<div class='btn field map' data-id='" + pMap['id'] + "' data-marker-lng='" + markerLng + "' data-marker-lat='" + markerLat + "' data-marker='" + marker + "' data-style='" + style + "' data-zoom='" + zoom + "' data-viewzoom='" + viewZoom + "' data-lat='" + lat + "'  data-lng='" + lng + "' style='" + css + "'><i class='fas fa-map-marker-alt'></i>" + pMap['name'] + "</div>";
    }

    function generateWrapper(pWrapper) {
        let html = "<div class='wrapper' data-id-group='" + pWrapper['id'] + "'>";
        html += generate(pWrapper['fields']);
        html += "</div>";
        return html;
    }

    function getIconName(pType, pName) {
        var key = (pType + "_" + pName).toLowerCase();

        switch (key) {
            case 'text_date':
            case 'text_datumtext':
                return 'fas fa-calendar-day';
            case 'dropdown_spruch':
                return 'fas fa-quote-right';
            default:
                return "fas fa-font";
        }
    }
}